/* istanbul ignore file */
import {
    RECEIVE_USER,
    REQUEST_USER,
    SET_KEYCLOAK_TOKEN,
} from './types'

export function updateKeycloakAuthToken (tokens) {
    return {
        type: SET_KEYCLOAK_TOKEN,
        tokens,
    }
}

export function requestUser () {
    return {
        type: REQUEST_USER,
    }
}
export function receiveUser (user, status = {status: 'success', error: null}) {
    return {
        type: RECEIVE_USER,
        user,
        status,
    }
}
